import { useContext, useEffect } from "react";
import { GrupoContext } from "../context/GrupoContext";
import { UserContext } from "../context/UserContext";
import { AlertContext } from "../context/AlertContext";
import "../css/Invitaciones.css";

type Props = { onClose: () => void };

const ModalSolicitudes = ({ onClose }: Props) => {
  const grupoCtx = useContext(GrupoContext);
  const userCtx = useContext(UserContext);
  const alertCtx = useContext(AlertContext);

  const user = userCtx?.user ?? null;
  const showAlert = alertCtx?.showAlert ?? (() => {});

  const cargarInvitacionesRecibidas = grupoCtx?.recargarInvitaciones;  // <-- CORREGIDO
  const responderInvitacion = grupoCtx?.responderInvitacion;
  const solicitudes = grupoCtx?.invitacionesRecibidas ?? [];

  useEffect(() => {
    if (user && cargarInvitacionesRecibidas) {
      cargarInvitacionesRecibidas(); // <-- ahora sí existe
    }
  }, [user]);

  if (!grupoCtx || !user) return null;

  return (
    <div className="panel-overlay" onClick={onClose}>
      <div className="panel" onClick={(e) => e.stopPropagation()}>
        <button className="panel-close" onClick={onClose}>
          &times;
        </button>

        <h2>Solicitudes pendientes</h2>
        <hr />
        <div style={{ marginTop: 20 }}>
          {solicitudes.length === 0 && <p>No tenés solicitudes</p>}

          {solicitudes.map((s: any) => (
              <div
                key={s.id}
                className={`inv-card inv-${s.estado}`}
              >
                <div className="inv-info">
                  <strong>{s.remitente}</strong>
                  <span className="inv-status">{s.estado}</span>
                </div>

                {s.estado === "pendiente" && (
                  <div className="solicitud-actions">
                    <button
                      className="btn-aceptar"
                      onClick={async () => {
                        try {
                          await responderInvitacion?.(s.id, "aceptada");
                          await cargarInvitacionesRecibidas?.();
                          showAlert("Solicitud aceptada", "success");
                        } catch {
                          showAlert("Error al aceptar", "error");
                        }
                      }}
                    >
                      Aceptar
                    </button>

                    <button
                      className="btn-rechazar"
                      onClick={async () => {
                        try {
                          await responderInvitacion?.(s.id, "rechazada");
                          await cargarInvitacionesRecibidas?.();
                          showAlert("Solicitud rechazada", "success");
                        } catch {
                          showAlert("Error al rechazar", "error");
                        }
                      }}
                    >
                      Rechazar
                    </button>
                  </div>
                )}
              </div>
            ))}

        </div>
      </div>
    </div>
  );
};

export default ModalSolicitudes;
